import React from 'react';
import Reflux from 'reflux';
import {Button, Row, Col, Modal, Radio, Select, Input, Table, Dropdown, Icon, Menu, message} from 'antd';
import {hashHistory, withRouter} from 'react-router';
import {DmsTab, FilterBox, TableView} from '../../components';
import { openNotice } from 'Utils';
import { getCommentList, approveComments, commentTop } from '../../service/comment'; /*获取产品列表接口*/
class CommentList extends Reflux.Component {
  constructor(props) {
    super(props);
    this.state = {
      opts: ['全部评论'],
      filterBoxVisible: false,
      showHideBtnIndex: '',
      key: 0,
      selectedRowKeys: [],
      selectedKeys: [],
      selectedRows: [],
      rows: [],
      total: 1,
      searchObj: {
        keyword: '',
        type: '0',
        isApprove:'',
        s: 10,
        p: 1
      },
      searchApproveObj: [ // 批量审核or删除、置顶参数
        // {
        //   id: '',
        //   type: '',  // 评论类型，1为资讯评论，2为产品评论，3为渠道赋能评论
        //   status: ''  // 是否置顶：0否，1是
        // }
      ],
      categoryData: [],
      visible: false,
      value: ''
    };

  };
  /*选择列表*/
  onSelectChange = (selectedRowKeys, selectedRows) => {
    this.setState({selectedRowKeys, selectedRows});
  };
  /*路径跳转*/
  goView(url) {
    hashHistory.push(url);
  };

  /*翻页*/
  pageChange = (page, pageSize) => {
    let self = this;
    this.setState({ searchObj: { ...this.state.searchObj, s: pageSize, p: page } }, function () {
      self.initData();
    });
  }
  /*获取列表数据*/
  initData () {
    let obj = this.state.searchObj;
    getCommentList(obj).then(res => {
      if (res.status) {
        this.setState({
          rows: res.data || [],
          total: res.total
        })
      } else {
        message.error(res.message);
      }
    });
  }

  /* 批量审核or删除接口 */
  approveComments(arr) {
    approveComments(arr).then(res => {
      if (res.status) {
        openNotice('success', '操作成功', '');
        this.initData();
      } else {
        message.error(res.message);
      }
    });
  }

  /* 是否置顶 */
  commentTop(arr) {
    commentTop(arr).then(res => {
      if (res.status) {
        message.success('置顶成功');
        this.initData();
      } else {
        message.error(res.message);
      }
    });
  }

  //离开当前路由时，更新store
  routeLeaveHook = (nextLocation) => {
  }

  componentWillMount () {
  }

  componentDidMount () {
    this.initData();
    //设置离开当前路由时的钩子函数
    this.props.router.setRouteLeaveHook(this.props.route, this.routeLeaveHook);
  }

  showHideBtn (index) {
    this.setState({
      showHideBtnIndex: index
    });
  }

  hideBtn () {
    this.setState({
      showHideBtnIndex: ''
    });
  }

  addRecord(index) {
    console.log('adding ' + index);
  }

  handleOk = () => {
    this.setState({ visible: false });
  }
    
  handleCancel = () => {
    this.setState({ visible: false });
  }

  onChange = (e) => {
    // console.log('radio checked', e.target.value);
    this.setState({
      value: e.target.value
    });
  }

  handleChange = () => {
  }

  /*筛选*/
  visibleChange = () => {
    this.setState({ filterBoxVisible: !this.state.filterBoxVisible });
  }

  onVisibleChange = (visible) => {
    this.setState({
      selectedKeys:[]
    });
  }

  /* 单条处理 */
  dropdownClick = ({item, key, keyPath}) => {
    const {selectedKeys} = this.state;
    selectedKeys.push(key);
    this.setState({
      selectedKeys
    });
    var arr = key.split('_')
      , item = this.state.rows[arr[1]]
      ;
    // let _type = item.type == '资讯评论' ? 1 : 2;  // 1为资讯评论，2为产品评论，3为渠道赋能评论
    let _type = 0;
    switch(item.type) {
      case '资讯评论':
        _type = 1;
      break;
      case '产品评论':
        _type = 2;
      break;
      case '渠道赋能评论':
        _type = 3;
      break;
    }
    if (arr[0] === '0') {
      /* 删除 */
      // console.log('Deleting...');
      this.approveComments([
        {
          id: item.id,
          type: _type,
          status: 1   // 1删除
        }
      ]);
    } else if (arr[0] === '1') {  
      /* 置顶 */
      // console.log('Stick to the top...');
      let _status = item.isTop == '是' ? 0 : 1;
      this.commentTop([
        {
          id: item.id,
          type: _type,
          status: _status
        }
      ]);
    } else {
      /* 审核 */
      // console.log('Verifying...');
      this.approveComments([
        {
          id: item.id,
          type: _type,
          status: 0   // 0审核
        }
      ]);
    }
  }

  /* 下拉操作 */
  dropMenu(record, index) {
    // console.log(record);
    /*return (
      <Menu style={{width: "100px", textAlign: 'center'}} onClick={this.dropdownClick}
        selectedKeys={this.state.selectedKeys}>
        <Menu.Item key={`0_${index}`}>删除</Menu.Item>
        <Menu.Item key={`1_${index}`}>置顶</Menu.Item>
        <Menu.Item key={`2_${index}`}>审核</Menu.Item>
      </Menu>
    )*/
    /*{if (record.status == '通过') {
      return (
        <Menu style={{width: "100px", textAlign: 'center'}} onClick={this.dropdownClick.bind(this, record, index)}
          selectedKeys={this.state.selectedKeys}>
          <Menu.Item key={`0_0`}>删除</Menu.Item>
          <Menu.Item key={`1_1`}>置顶</Menu.Item>
        </Menu>
      )
    } else {
      return (
        <Menu style={{width: "100px", textAlign: 'center'}} onClick={this.dropdownClick.bind(this, record, index)}
          selectedKeys={this.state.selectedKeys}>
          <Menu.Item key={`0_0`}>删除</Menu.Item>
          <Menu.Item key={`1_1`}>置顶</Menu.Item>
          <Menu.Item key={`2_2`}>审核</Menu.Item>
        </Menu>
      )
    }}*/
    return (
      <Menu style={{width: "100px", textAlign: 'center'}} onClick={this.dropdownClick}
        selectedKeys={this.state.selectedKeys}>
        <Menu.Item key={`0_${index}`}>删除</Menu.Item>
        <Menu.Item key={`1_${index}`}>置顶</Menu.Item>
        {record.status != '通过'? <Menu.Item key={`2_${index}`}>审核</Menu.Item>: ''}
      </Menu>
    )
  }

  /* 批量审核 */
  batchReview = () => {
    // console.log(this.state.selectedRows);
    let _rows = this.state.selectedRows
      , _arr = []
      ;
    _rows.map(x => {
      if (x.status != '通过') {
        // let _type = x.type == '资讯评论' ? 1 : 2;  // 1为资讯评论，2为产品评论，3为渠道赋能评论
        let _type = 0;
        switch(x.type) {
          case '资讯评论':
            _type = 1;
          break;
          case '产品评论':
            _type = 2;
          break;
          case '渠道赋能评论':
            _type = 3;
          break;
        }
        _arr.push({
          id: x.id,
          type: _type,
          status: 0   // 0审核
        })
      }
    });
    if (!_arr.length) {
      message.warning('请至少选择一条未审核的评论');
      return;
    }
    this.approveComments(_arr);
  }

  /* 筛选重置 */
  advanceReset = () => {
    this.setState({
      // filterBoxVisible: false,
      searchObj: {
        keyword: '',
        type: '0',
        isApprove:'',
        s: 10,
        p: 1
      }
    }, () => {
      this.initData();
    });
  };

  /* 确认筛选 */
  advanceSubmit = (form) => {
    this.setState({
      filterBoxVisible: false,
      searchObj: {
        ...this.state.searchObj,
        p: 1
      }
    }, () => {
      this.initData();
    });
  };

  /* 筛选变动 */
  setFilterParam = (name, value) => {
    // console.log(name + ':\t' + value);
    this.setState({
      searchObj: {
        ...this.state.searchObj,
        [name]: value
      }
    });
  };

  render() {
    var self = this;
    const {filterBoxVisible, opts, key, rows, total, searchObj, selectedRowKeys, showHideBtnIndex, visible} = this.state;
    const tableViewProps = {
      loading: false,//更新表格数据中
      rowKey: 'no',
      pageParam: {
        total,
        current: searchObj.p,//当前页码
        pageSize: searchObj.s,//当前分页数
        onChange: this.pageChange
      },
      columns: [
        {
          title: '评论',
          dataIndex: 'content'
        }, {
          title: '评论人',
          dataIndex: 'name'
        },
        {
          title: '状态',
          dataIndex: 'status'
        },
        {
          title: '评论类型',
          dataIndex: 'type'
        },
        {
          title: '发布时间',
          dataIndex: 'commentTime'
        },
        {
          title: '',
          dataIndex: 'action',
            render: (text, record, index) => (
            <Dropdown overlay={this.dropMenu(record, index)}
              placement='bottomCenter'
              trigger={['click']}
              onVisibleChange={this.onVisibleChange}>
              <span className="ant-dropdown-link">
                <Icon type="caret-down"/>
              </span>
            </Dropdown>
          )
        }
      ],
      rows,
      rowSelection: {
        selectedRowKeys: selectedRowKeys,
        onChange: self.onSelectChange
      }
    }
    // const rowSelection = {
    //   selectedRowKeys: selectedRowKeys,
    //   onChange: self.onSelectChange
    // };

    const filterBoxProps = {
      showFlag: filterBoxVisible,
      advance: {
        fileds: [
          {
            name: 'keyword',
            label: '筛选规则',
            text: '关键字',
            defaultValue: searchObj.keyword || '',
            type: 'default'
          },
          {
            name: 'type',
            label: '评论类型',
            text: "",
            defaultValue: '',
            options: [
              {value: '0', text: '全部'},
              {value: '2', text: '产品评论'},
              {value: '1', text: '资讯评论'}
            ],
            type: 'select'
          },
          {
            name: 'isApprove',
            label: '状态',
            text: "",
            defaultValue: '',
            options: [
              {value: '0', text: '待审核'},
              {value: '1', text: '通过'},
              {value: '2', text: '已驳回'}
            ],
            type: 'select'
          }
        ],
        handle: this.advanceSubmit,
        reset: this.advanceReset,
        fieldHandle: this.setFilterParam
      }
    };
      // <Table bordered={false} dataSource={rows} columns={columns} rowSelection={rowSelection} pagination={false}/>
    return (
      <div>
        <DmsTab options={opts} defaultKey={key}>
          <Button onClick={this.batchReview}>审核</Button>
          <Button onClick={this.visibleChange}>筛选</Button>
          <FilterBox {...filterBoxProps}/>
        </DmsTab>
        <div className="dms-table-box">
          <TableView {...tableViewProps}/>
        </div>
      </div>
    );
    
  }
}
;
export default withRouter(CommentList);


// WEBPACK FOOTER //
// ./src/routes/comment/list.js